import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

import { environment } from '../../environments/environment';
import { ServicesService } from '../services/services.service';
import { ProjectDialog } from './project.dialog';

// import { FormControl ,FormGroup, Validators } from '@angular/forms';
// import {HttpErrorResponse} from '@angular/common/http';
// import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.css"]
})

export class ProjectComponent implements OnInit {
  fields: any = [];
  listData: any = [];
  employeeList;
  taskList;
  taskDetail;

  public routePath;
  public loading = false;
  isLoader: boolean = false;
  public show: boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  spinLoader = {
    filter: false,
    delete: []
  };

  isListData = true;
  isOnePage = false;
  route: string;
  isListDataEmpty = false;
  apiUrl = environment.apiUrl;
  municipalno: any;
  routepath: any;
  projectUpdateForm: FormGroup;
  //this variable was used to make the form select element readonly but it is no longer in use now
  isReadonly: boolean = false;
  email: string;

  constructor(private _services: ServicesService, private router: Router, private activeroute: ActivatedRoute, private formBuilder: FormBuilder, public dialog: MatDialog) {
    this.activeroute.queryParams.subscribe(params => {
      this.municipalno = params["maintenance_id"];

      // //console.log(this.municipalno);
    });
  }

  ngOnInit() {
    this._services.checkToken("status");
    this.getPageRequest();
    this.taskDetail = new FormArray([]);
    const token = localStorage.getItem("userToken");
    this.projectUpdateForm = this.formBuilder.group({
      taskList: this.taskDetail
    });
    this.getEmployee();
    if (this.municipalno) {
      this.routepath = this.apiUrl + "/get-maintenancedetail-project-pdf?construction_id=" + this.municipalno + "&project_id=";
    } else {
      this.routepath = this.apiUrl + "/get-constructionsdetail-project-pdf?project_id=";
    }

    this.fields = [
      {
        field: "project_name",
        title: "Project Name",
        width: "30%",
        code: true,
        sort: true
      },
      {
        field: "project_start_date",
        title: "Project Start Date",
        width: "25%",
        code: false,
        sort: true
      },
      {
        field: "unit_completed",
        title: "Completed Construction ",
        width: "25%",
        code: false,
        sort: true
      }
    ];
    this.searchFields["project_type"] = "";
  }

  sendConstructionSummaryMail(data) {
    let token = this._services.getToken();
    //console.log("data", data, token)
    this._services.constructionSummaryMail(data, token).subscribe((result: any) => {
      this._services.checkToken(result.status)
      if (result.status == '200') {
        swal({
          title: "Construction Email Sent.",
          text: "Construction  Email Sent Successfully!",
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "rgb(17, 205, 239)",
          cancelButtonColor: "rgb(245, 54, 92)",
          confirmButtonText: "Yes"
        })
      }
    });
  }
  openDialog(project_id): void {
    const dialogRef = this.dialog.open(ProjectDialog, {
      width: '350px',
      data: { email: this.email }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log("The dialog was closed", result);
      if (result) {
        let data = {
          email: result,
          project_id
        };
        this.sendConstructionSummaryMail(data)
      }
    })
  }

  getSampleArrayControls() {
    // //console.log(this.taskAssignForm.get('tasks'));
    return (<FormArray>this.projectUpdateForm.get("taskList")).controls;
  }

  getEmployee() {
    this.routePath = "get-employee-names";
    let token = this._services.getToken();
    let data = {};
    //console.log("employeetoken", token)
    this._services.postRequest(data, this.routePath, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == "200") {
        this.employeeList = data.result;
      }
    });
  }

  resetSearchField() {
    this.spinLoader["filter"] = true;
    this.searchFields = [""];
    this.getPageRequest();
  }

  getSearchRequest() {
    this.spinLoader["filter"] = true;
    this.getPageRequest();
  }

  status: any;

  deleteProject(id) {
    // if (this.status) {
    this.route = "delete-project";
    let token = this._services.getToken();
    var data = {
      id: id
    };

    swal({
      title: "Are you sure?",
      text: "Delete Project?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#163862",
      confirmButtonText: "Yes",
      cancelButtonColor: "rgb(245, 54, 92)"
    }).then(result => {
      // alert(result.value);
      if (result.value === true) {


        this._services.postRequest(data, this.route, token).subscribe((data: any) => {


          window.location.reload();

        });
      }

      // this.listData = data.result;
      // this.paginate = data.paginate;
      // this.getPages(this.paginate.last_page);
    });

    // }
  }

  sortType: string = "";
  sortField: string = "";
  oldField: string;
  sortingData = {
    field: "",
    type: ""
  };

  sortBy(field, event) {
    this.spinLoader["filter"] = true;
    this.oldField = this.oldField != field ? this.oldField : field;

    if (typeof this.oldField !== "undefined") {
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById("fa-" + this.oldField).classList.remove("fa-sort-up");
      document.getElementById("fa-" + this.oldField).classList.remove("fa-sort-down");
      document.getElementById("fa-" + this.oldField).classList.add("fa-sort");
    }

    event.target.classList.add("fa");

    this.sortField = field;
    this.sortType = this.sortType == "desc" ? "asc" : "desc";

    switch (this.sortType) {
      case "desc":
        {
          event.target.classList.remove("fa-sort-up");
          event.target.classList.add("fa-sort-down");
          this.oldField = field;
        }
        break;
      case "asc":
        {
          event.target.classList.remove("fa-sort-down");
          event.target.classList.add("fa-sort-up");
          this.oldField = field;
        }
        break;
      default: {
        event.target.classList.add("fa-sort");
      }
    }

    this.sortingData = {
      field: this.sortField,
      type: this.sortType
    };

    this.getPageRequest();
  }
  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate = {
    last_page: 1
  };
  searchFields = [];
  pages: any;
  //   listData = [];
  editData: Object = {};

  previousPage() {
    if (this.currentPage == 1) {
      return;
    }

    this.currentPage = this.currentPage - 1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  nextPage() {
    if (this.paginate.last_page - 1 < this.currentPage) {
      return;
    }

    this.currentPage++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage() {
    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n) {
    if (n > 1) {
      this.isOnePage = true;
    } else {
      this.isOnePage = false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
  routeData: string;
  totalData: any;
  getPageRequest() {
    let data;
    this.routeData = "get-project-list-web";
    switch (this.routeData) {
      case "get-project-list-web": {
        data = {
          page: this.currentPage,
          search: {
            project_name: this.searchFields["project_name"],
            maintenanceid: this.municipalno,
            cont_name: this.searchFields["cont_name"],
            project_type: this.searchFields["project_type"]
          },
          sort: this.sortingData
        };
        break;
      }
    }

    this.loading = true;
    const token = localStorage.getItem("userToken");
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        this.spinLoader["filter"] = false;
        this.isListData = false;

        this.listData = [];
        this.listData = result.result;
        // //console.log(this.listData);
        this.totalData = result.paginate.total;
        this.paginate = result.paginate;

        this.currentPage = result.paginate.current_page;
        if (this.listData.length == 0) {
          this.isListDataEmpty = true;
        } else {
          this.isListDataEmpty = false;
        }
        if (result.paginate.current_page > result.paginate.last_page) {
          this.currentPage = result.paginate.last_page;
        }

        this.getPages(this.paginate.last_page);

        for (let key in this.spinLoader) {
          if (key == "delete") {
            this.spinLoader[key] = [];
          } else {
            this.spinLoader[key] = false;
          }
        }
      }
    });

    return true;
  }

  private taskAssigned(user_id, project_id, contractor, units, cont_id, readOnly, total_unit): any {
    return this.formBuilder.group({
      contractor_name: [contractor, Validators.required],
      construction_unit: [units, Validators.required],
      cont_id: [cont_id, Validators.required],
      project_id: [project_id, Validators.required],
      total_unit: [total_unit, Validators.required],
      user_id: [{ value: user_id ? user_id : "", disabled: !!readOnly }, Validators.required]
    });
  }

  projectData = {
    project_name: "",
    project_location: "",
    project_start_date: "",
    municipality: "",
    project_manager_name: "",
    project_manager_no: "",
    project_unit: "",
    unit_completed: "",
    first_name: "",
    user_id: "",
    id: "",
    contractor_data: [],
    cont_name: "",
    project_type: ""
  };
  Show(userData) {
    this.projectData = userData;
    //console.log(userData);

    // if (this.projectData.unit_completed == '0') {
    //   this.isReadonly = false;
    // } else {
    //   this.isReadonly = true;
    // }
    (<FormArray>this.projectUpdateForm.get("taskList")).controls = [];
    for (var i = 0; i < userData.contractor_data.length; i++) {
      this.taskList = this.projectUpdateForm.get("taskList") as FormArray;
      this.taskList.push(this.taskAssigned(this.projectData.user_id, this.projectData.id, this.projectData.contractor_data[i].contractors, this.projectData.contractor_data[i].units, this.projectData.contractor_data[i].cont_id, this.isReadonly, this.projectData.project_unit));
    }
    this.projectUpdateForm.patchValue({ user_id: this.projectData.user_id });
    this.projectUpdateForm.patchValue({ project_id: this.projectData.id });
    this.show = true;
    //console.log(this.projectData.project_type);

  }

  back() {
    this.show = false;
    this.getPageRequest();
  }

  updateProject() {
    this.routePath = "update-project-details";
    let token = this._services.getToken();
    this._services.postRequest(this.projectUpdateForm.value, this.routePath, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == "200") {
        swal({
          title: "Construction",
          text: "Construction Updated Successfully",
          type: "success",
          showCancelButton: false,
          confirmButtonColor: "rgb(17, 205, 239)",
          cancelButtonColor: "rgb(245, 54, 92)",
          confirmButtonText: "Yes"
        });
        this.back();
        // this.employeeList = data.result;
      } else {
        swal("Attention", "Entered Contractor Units is greater than the Total Unit", "warning");
      }
    });
  }
}
